module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAASFBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////neHiwAAAAGHRSTlMAJIPH3/+/exgEi/v3c6OTMJvj50CrDNeNoElnAAAAnklEQVR4Ae3UQRZEMBRE0UIqBKDRvf+d9gp+BvIHDnU38GYPdyQiUtVN4EUhth3yUj+wyDghJ0UWm5Gx0MEE00oPYwfLRhctLIEuIiz0EZwCticGFFAAhjcGFFCAhqcGFFBAq1BAAa1CAQW0CgUUKKeAAgrwA8tOFw0sM13UsBz0MFQwnXTQw/b9sVhMyBVOFloS8o5552VhW3FDIiJ/1mZYCjonDCwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/code-white-icon.png
// module id = 320
// module chunks = 0